import React, { useState } from "react";
import { Twitter, Facebook, Linkedin, Mail } from "lucide-react";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would add the newsletter signup logic
    alert(`Thank you for subscribing with: ${email}`);
    setEmail("");
  };

  const handleSocialClick = (platform) => {
    // In a real app, this would open a link to the social media platform
    alert(`Opening ${platform} page would happen here`);
  };

  return (
    <footer className="bg-primary-700 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Footer section 1 - About */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Carbon2Capital</h3>
            <p className="text-white text-opacity-80 mb-4">
              Climate change is here. It's personal—and we can make a
              difference.
            </p>
            <p className="text-sm text-white text-opacity-60">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          {/* Footer section 2 - Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Stay Connected</h3>
            <form onSubmit={handleSubmit} className="mb-4">
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="px-3 py-2 text-gray-800 rounded-l-md w-full focus:outline-none"
                  required
                />
                <button
                  type="submit"
                  className="bg-edu-orange px-4 py-2 rounded-r-md hover:bg-opacity-90 transition-colors"
                >
                  Subscribe
                </button>
              </div>
            </form>
            <p className="text-sm text-white text-opacity-60">
              Join our newsletter for climate updates and course improvements.
            </p>
          </div>

          {/* Footer section 3 - Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <button
                onClick={() => handleSocialClick("Twitter")}
                className="text-white hover:text-edu-sky transition-colors"
                aria-label="Follow us on Twitter"
              >
                <Twitter size={20} />
              </button>
              <button
                onClick={() => handleSocialClick("Facebook")}
                className="text-white hover:text-edu-sky transition-colors"
                aria-label="Follow us on Facebook"
              >
                <Facebook size={20} />
              </button>
              <button
                onClick={() => handleSocialClick("LinkedIn")}
                className="text-white hover:text-edu-sky transition-colors"
                aria-label="Connect with us on LinkedIn"
              >
                <Linkedin size={20} />
              </button>
              <button
                onClick={() => handleSocialClick("Email")}
                className="text-white hover:text-edu-sky transition-colors"
                aria-label="Contact us via Email"
              >
                <Mail size={20} />
              </button>
            </div>
            <div className="mt-4">
              <button
                onClick={() => alert("Terms of Service page would open here")}
                className="text-sm text-white text-opacity-80 hover:text-opacity-100"
              >
                Terms of Service
              </button>
              <span className="mx-2 text-white text-opacity-60">|</span>
              <button
                onClick={() => alert("Privacy Policy page would open here")}
                className="text-sm text-white text-opacity-80 hover:text-opacity-100"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white border-opacity-20 text-center text-sm text-white text-opacity-60">
          <p>
            © {new Date().getFullYear()} Carbon Literacy Course. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
